import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AreaTabs } from '@/features/nav/AreaTabs';
import { PageActionsSlot } from '@/features/nav/PageActions';

export const Route = createFileRoute('/_authenticated/attendance')({
  component: () => (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <h1 className="text-2xl">Chấm công</h1>
        <PageActionsSlot />
      </div>
      <AreaTabs areaId="attendance" />
      <Outlet />
    </div>
  ),
});
